import { trans } from '@spotahome/soyuz/client';
import { formatPrice } from '@spotahome/soyuz-currency';

const SECURITY_DEPOSIT_TRANSLATIONS = {
  5000: 'listing.fees.deposit.half-month',
  10000: 'listing.fees.deposit.one-month',
  15000: 'listing.fees.deposit.one-month-and-half',
  20000: 'listing.fees.deposit.two-months',
  30000: 'listing.fees.deposit.three-months'
};

export const getSecurityDepositValue = (
  currency,
  cityId,
  contractDurationType,
  depositValue,
  depositType,
  hasDates
) => {
  const isPermanentContract = contractDurationType === 'permanent';

  if (depositType === 'noSecurityDeposit') {
    return formatPrice(0, currency);
  }

  if (cityId === 'paris') {
    return trans(
      'booking_request.landlord_payments_timeline.elan_compliance_deposit_note'
    );
  }

  if (
    !hasDates &&
    !isPermanentContract &&
    depositValue !== 0 &&
    depositType !== 'fixed'
  ) {
    return trans(`${SECURITY_DEPOSIT_TRANSLATIONS[depositValue]}`);
  }

  if (depositType === 'notDefined') {
    return trans('rentableunit.label.not_available');
  }

  return formatPrice(depositValue, currency);
};
